export const CSS_CLASS_BLOCK_NAME = 'bb-recommendations';
export const CSS_HIDDEN_CSS_MODIFIER = `${CSS_CLASS_BLOCK_NAME}--hidden`;
export const HEADER_CSS_CLASS_BLOCK_NAME = `${CSS_CLASS_BLOCK_NAME}__header`;
export const FOOTER_CSS_CLASS_BLOCK_NAME = `${CSS_CLASS_BLOCK_NAME}__footer`;
export const NAVIGATION_CSS_CLASS_BLOCK_NAME = `${CSS_CLASS_BLOCK_NAME}__navigation`;
export const RECOMMENDED_SELECTION_CSS_ATTR = 'data-recommended-selection';
export const RECOMMENDED_SELECTION_GTM_ATTR = 'data-spectate-product';
export const RECOMMENDED_SELECTION_GTM_ADD_BET = 'recommendation;add-to-bet-slip';
export const RECOMMENDED_SELECTION_GTM_SWIPE = 'recommendation;swipe';
export const SELECTIONS_RIGHT_PADDING_CLASS_BLOCK_NAME = `${CSS_CLASS_BLOCK_NAME}__selections-right-padding`;
export const NAVIGATION_DISABLED_CSS_MODIFIER = `${NAVIGATION_CSS_CLASS_BLOCK_NAME}--disabled`;
export const NAVIGATION_LEFT_CSS_MODIFIER = `${NAVIGATION_CSS_CLASS_BLOCK_NAME}--left`;
export const NAVIGATION_RIGHT_CSS_MODIFIER = `${NAVIGATION_CSS_CLASS_BLOCK_NAME}--right`;
export const TITLE_CSS_CLASS_BLOCK_NAME = `${CSS_CLASS_BLOCK_NAME}__title`;
export const SELECTIONS_CSS_CLASS_BLOCK_NAME = `${CSS_CLASS_BLOCK_NAME}__selections`;
export const SELECTION_CSS_CLASS_BLOCK_NAME = `${CSS_CLASS_BLOCK_NAME}__selection`;
export const NUMBER_OF_BETS_CSS_CLASS_BLOCK_NAME = `${CSS_CLASS_BLOCK_NAME}__number-of-bets`;
export const I18N_PREFIX = 'bs_recommends';
export const TITLE_TEXT = `${I18N_PREFIX}.title_text`;
export const TITLE_TEXT_DEFAULT = `${I18N_PREFIX}.title_text_default`;
export const SELECTION_VIEW_LEFT_MARGIN = 30;
export const NEXT_SELECTION_VIEW_SHOWN_EVENT = 'next:selection:view:shown';
export const PREV_SELECTION_VIEW_SHOWN_EVENT = 'prev:selection:view:shown';
export const SELECTION_VIEW_SHOWN_EVENT = 'selection:view:shown';
export const SELECTION_VIEWS_SHOWN_EVENT = 'selection:views:shown';
export const SLIDE_ANIMATION_DELAY_IN_MILLI_SECONDS = 500;
